//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _person from './person';
export const person = _person;
export default {person};

